module.exports = __webpack_public_path__ + "images/building-icon-alt-b0b2d48929aa3741e1cd8b4924f4672f.svg";